import React, { useEffect, useState } from 'react';
import { styles } from "./styles";
import { Grid, Button, LinearProgress, Typography, TextField, Icon, IconButton } from "@mui/material";
import DataMuiSelect from 'components/MuiSelect/DataMuiSelect';
import { styles as inputStyles } from "common/inputStyles";
import TipPushStatusTableHeader from 'components/TableHeader/TipPushStatusTableHeader';
import TipPushStatusDataTable from 'components/DataTable/TipPushStatusDataTable';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { getAllFailedTipPushEvents } from 'apis/device';
import moment from "moment";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import CommonUtil from 'common/CommonUtil';
import ErrorPopup from 'common/ErrorPopup';

// LicenseManager.setLicenseKey("CompanyName=Rehrig Pacific Company (Richardson, TX),LicensedApplication=Rehrig Vision,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-037353,SupportServicesEnd=29_December_2024_[v2]_MTczNTQzMDQwMDAwMA==2cc2796737bee66cd2e64e46b6c5759c")
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-083627}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Rehrig_Pacific_Company_(Richardson,_TX)}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Rehrig_Vision}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Rehrig_Vision}_need_to_be_licensed___{Rehrig_Vision}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{29_December_2026}____[v3]_[01]_MTc5ODUwMjQwMDAwMA==1b7092d629f412070d31d438941b4c34")

interface TipPushStatusReportProps {
}

var pgNumber = 0;
var records: any = [];
const TipPushStatusReport: React.FC<TipPushStatusReportProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deviceData, setDeviceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");
  const [showCont, setShowCont] = useState(false);
  const [events, setEvents] = useState<any>(null);
  const [eventsData, setEventsData] = useState<any>(CommonUtil.tipevents);
  const [fromvalue, setFromvalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [tovalue, settovalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [isFromDateError, setFromDateError] = useState(false);
  const [isToDateError, setToDateError] = useState(false);
  const [showErrorPopup,setShowErrorPopup] = useState(false);
  const [checkedData, setCheckedData] = useState<any>(null);
  const [formattedData, setFormattedData] = useState<any>(null);
  const [isEventError, setEventError] = useState(false);
  const [tipStatusRepoAfterFilter, setTipStatusRepoAfterFilter] = useState([]);

  const getAllTipPushStatuses = async () => {
      let eType = (events) ? events.value : "";
      setDeviceData([]);
      records = [];
      pgNumber = 1; 
      let data = await getAllFailedTipPushEvents(eType, pgNumber);
      if (data) {
        records = records.concat(data.records);
        if(data.hasMore){
          while(true){
            pgNumber = pgNumber + 1;
            data = await getAllFailedTipPushEvents(eType, pgNumber);
            if(data){
                records = records.concat(data.records);
            }
            if(records.length>=CommonUtil.TIP_STATUS_COUNT){
              setShowErrorPopup(true);
              break;
            }
            if(!data.hasMore){
              break;
            }
          }
        }
        records.forEach((object: any) => {
          if ('eventDate' in object && object.eventDate !== null) {
              const obj = object.eventDate;
              if(obj.includes('+0000')){
                const date = new Date(object.eventDate);
                object.eventDate = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
              }
              else{
                object.eventDate = new Date(object.eventDate).toLocaleString();
              }
          }
          if ('creationDate' in object && object.creationDate !== null) {
            const obj = object.creationDate;
            if(obj.includes('+0000')){
              const date = new Date(object.creationDate);
              object.creationDate = moment.parseZone(date).utc().format('MM/DD/YYYY h:mm:ss A');
            }
            else{
              object.creationDate = new Date(object.creationDate).toLocaleString();
            }
        }
        });
        const sortedArray = records.sort((a: any, b: any) => {
          const dateA = new Date(a.creationDate);
          const dateB = new Date(b.creationDate);
          if (dateA > dateB) {
            return -1;
          } else if (dateA < dateB) {
            return 1;
          } else {
            return 0;
          }
        });
        let newArr = sortedArray.filter((s: any) => s.creationDate !== null);
        setDeviceData(sortedArray);
      }
      else {
        pgNumber = 0;
        setDeviceData([]);
        setIsLoading(false);
      }
  }

  useEffect(() => {
    pgNumber = 0;
    records = [];
  }, [])

  const ChangeEventsHandler = (data: any) => {
    setEvents(data)
    setEventError(!data || data.length === 0);
  }

  const getDateValeus = () => {
    localStorage.removeItem('fromDate');
    localStorage.removeItem('toDate');
    let date: any = fromvalue?.get('date');
    let month: any = fromvalue?.get('month');
    let year: any = fromvalue?.get('year');

    let newMonth = month < 9 ? `0${month + 1}` : `${month + 1}`; //adding 0 to month if single digit
    let newdate = date < 10 ? `0${date}` : `${date}`; //adding 0 to date if single digit
    let fDate: any = `${newMonth}-${newdate}-${year}`;

    // getting value from toDate
    let tdate: any = tovalue?.get('date');
    let tmonth: any = tovalue?.get('month');
    let tyear: any = tovalue?.get('year');

    let tnewMonth = tmonth < 9 ? `0${tmonth + 1}` : `${tmonth + 1}`; //adding 0 to month if it is single digit
    let tnewdate = tdate < 10 ? `0${tdate}` : `${tdate}`; //adding 0 to date if it is single digit
    var tDate: any = `${tnewMonth}-${tnewdate}-${tyear}`;

    localStorage.setItem('fromDate', fDate);
    localStorage.setItem('toDate', tDate);
  }

  const getDeviceEvents = () => {
    if(isEventError || isFromDateError || isToDateError) {
      return false;
    }
    if(!events || events.length === 0) {
      setEventError(!events || events.length === 0);
      return false;
    }
    if(!fromvalue || !fromvalue.isValid()) {
      setFromDateError(!isFromDateError);
      return false;
    }
    if(!tovalue || !tovalue.isValid()) {
      setToDateError(!isToDateError);
      return false;
    }
    let hours = tovalue.diff(fromvalue, 'hours');
    const days = Math.floor(hours / 24);
    if(days > 6) {
      alert("Date range should not exceed 7 days.");
      return false;
    }
    if(days < 0) {
      alert("Invalid date range.")
      return false;
    }
    setIsLoading(true);
    setDeviceData([]);
    setFormattedData("");
    setCheckedData("");
    getDateValeus();
    getAllTipPushStatuses();
  }

  const closeErrorPopup = ()=>{
    setShowErrorPopup(false);
  }
      // Downloading Only Filtered Data After Search
      const updateFilteredData = (data:[]) => {
        setTipStatusRepoAfterFilter(data);
      }

  return (
    <Grid container spacing={2}>
      {isLoading && <LinearProgress />}
      {showModal ? (err !== "" && <Typography sx={styles.errContainer}>{err}</Typography>) : ""}
      {showErrorPopup?<ErrorPopup title='Data' popupText='10000 records loaded from available data' open={showErrorPopup} handlePopupClose={closeErrorPopup}></ErrorPopup>:""}
      <Grid container spacing={2} style={{ width: '100%', marginTop: '5px', padding: '15px' }}>
        <Grid item xs={3} sx={{ paddingTop: "15px" }}>
        <DataMuiSelect label={"Event Type"} sKey={"key"} value={"value"} selectedValue={events} dataSource={eventsData}
              onChangeHandler={(e: any) => ChangeEventsHandler(e)} 
              mandatory={true} isError={isEventError} errorText={"Required Field."}/>
        </Grid>
        <Grid item xs={3} sx={{ paddingTop: "15px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From"
              openTo="day"
              views={['year', 'month', 'day']}
              value={fromvalue}
              inputFormat="MM-DD-YYYY"
              onChange={(newValue) => {
                setFromvalue(newValue);
                  setFromDateError(!newValue  || !newValue.isValid());
                  setEventError(!events || events.length === 0);
              }}
                renderInput={(params) => <TextField  {...params} style={{ width: "100%" }} 
                required={true}
                error={isFromDateError || !fromvalue || !fromvalue.isValid()}
                helperText={isFromDateError ? ( !fromvalue ? "Requried Field.": "Invalid Date."):""}
                />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3} sx={{ paddingTop: "15px" }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To"
              openTo="day"
              views={['year', 'month', 'day']}
              value={tovalue}
              inputFormat="MM-DD-YYYY"
              onChange={(newValue) => {
                settovalue(newValue);
                  setToDateError(!newValue || !newValue.isValid());
                  setEventError(!events || events.length === 0);
              }}
                renderInput={(params) => <TextField {...params} style={{ marginBottom: "15px", width: "100%" }} 
                required={true}
                error={isToDateError || !tovalue || !tovalue.isValid() }
                helperText={isToDateError ? ( !tovalue? "Requried Field.": "Invalid Date."):""}
                />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid xs={3} sx={{ paddingTop: "15px", paddingLeft: '15px' }}>
          <Button sx={inputStyles.buttonGreen} onClick={getDeviceEvents}>Search</Button>
        </Grid>
      </Grid>

      <TipPushStatusTableHeader searchVal={searchVal} setSearchVal={setSearchVal} setShowCont={setShowCont} setFormattedData={setFormattedData} formattedData={formattedData} checkedData={checkedData} setCheckedData={setCheckedData} data={tipStatusRepoAfterFilter} csvLabel={"TipPushStatusReport.csv"} />
      <Grid item xs={12} sx={{ height: "80vh" }}>
        {/* {isLoading && <CircularProgress style={{position: 'absolute', top: 400, left: 700, zIndex: '1030'}}/>} */}
         {/* Added Filtered data Download after Search (getFilteredData={updateFilteredData} ) */}
        <TipPushStatusDataTable data={deviceData} searchVal={searchVal}  getFilteredData={updateFilteredData} />
      </Grid>
    </Grid>
  )
}

export default TipPushStatusReport;